import{LINE_SPACING_TYPE as e}from"./types.js";const o=Object.freeze({type:e,config:{}});export{o as DEFAULTS};
//# sourceMappingURL=defaults.js.map
